// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ZtsA0","content":"styles_content__YtYob","cardCollumnMobile":"styles_cardCollumnMobile___zvW3","icon":"styles_icon__wTcCT"};